/**
 * ![deepOrange 50](https://mui.com/static/colors-preview/deepOrange-50-24x24.png) ![deepOrange 100](https://mui.com/static/colors-preview/deepOrange-100-24x24.png) ![deepOrange 200](https://mui.com/static/colors-preview/deepOrange-200-24x24.png) ![deepOrange 300](https://mui.com/static/colors-preview/deepOrange-300-24x24.png) ![deepOrange 400](https://mui.com/static/colors-preview/deepOrange-400-24x24.png) ![deepOrange 500](https://mui.com/static/colors-preview/deepOrange-500-24x24.png) ![deepOrange 600](https://mui.com/static/colors-preview/deepOrange-600-24x24.png) ![deepOrange 700](https://mui.com/static/colors-preview/deepOrange-700-24x24.png) ![deepOrange 800](https://mui.com/static/colors-preview/deepOrange-800-24x24.png) ![deepOrange 900](https://mui.com/static/colors-preview/deepOrange-900-24x24.png) ![deepOrange A100](https://mui.com/static/colors-preview/deepOrange-A100-24x24.png) ![deepOrange A200](https://mui.com/static/colors-preview/deepOrange-A200-24x24.png) ![deepOrange A400](https://mui.com/static/colors-preview/deepOrange-A400-24x24.png) ![deepOrange A700](https://mui.com/static/colors-preview/deepOrange-A700-24x24.png)
 */
const deepOrange = {
  /**
   * Preview: ![deepOrange 50](https://mui.com/static/colors-preview/deepOrange-50-24x24.png)
   */
  50: '#fbe9e7',
  /**
   * Preview: ![deepOrange 100](https://mui.com/static/colors-preview/deepOrange-100-24x24.png)
   */
  100: '#ffccbc',
  /**
   * Preview: ![deepOrange 200](https://mui.com/static/colors-preview/deepOrange-200-24x24.png)
   */
  200: '#ffab91',
  /**
   * Preview: ![deepOrange 300](https://mui.com/static/colors-preview/deepOrange-300-24x24.png)
   */
  300: '#ff8a65',
  /**
   * Preview: ![deepOrange 400](https://mui.com/static/colors-preview/deepOrange-400-24x24.png)
   */
  400: '#ff7043',
  /**
   * Preview: ![deepOrange 500](https://mui.com/static/colors-preview/deepOrange-500-24x24.png)
   */
  500: '#ff5722',
  /**
   * Preview: ![deepOrange 600](https://mui.com/static/colors-preview/deepOrange-600-24x24.png)
   */
  600: '#f4511e',
  /**
   * Preview: ![deepOrange 700](https://mui.com/static/colors-preview/deepOrange-700-24x24.png)
   */
  700: '#e64a19',
  /**
   * Preview: ![deepOrange 800](https://mui.com/static/colors-preview/deepOrange-800-24x24.png)
   */
  800: '#d84315',
  /**
   * Preview: ![deepOrange 900](https://mui.com/static/colors-preview/deepOrange-900-24x24.png)
   */
  900: '#bf360c',
  /**
   * Preview: ![deepOrange A100](https://mui.com/static/colors-preview/deepOrange-A100-24x24.png)
   */
  A100: '#ff9e80',
  /**
   * Preview: ![deepOrange A200](https://mui.com/static/colors-preview/deepOrange-A200-24x24.png)
   */
  A200: '#ff6e40',
  /**
   * Preview: ![deepOrange A400](https://mui.com/static/colors-preview/deepOrange-A400-24x24.png)
   */
  A400: '#ff3d00',
  /**
   * Preview: ![deepOrange A700](https://mui.com/static/colors-preview/deepOrange-A700-24x24.png)
   */
  A700: '#dd2c00',
} as const;

export default deepOrange;
